import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AppContextService } from '../services/app-context.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const appContext = inject(AppContextService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      let errorMessage = '';

      if (typeof ErrorEvent !== 'undefined' && error.error instanceof ErrorEvent) {
        errorMessage = error.error.message;
      } else {
        switch (error.status) {
          case 400:
            errorMessage = 'Requisição inválida. Verifique os dados enviados.';
            break;
          case 401:
            errorMessage = 'Sessão expirada. Faça login novamente.';
            if (typeof window !== 'undefined') {
              const currentPath = window.location.pathname;
              if (currentPath !== appContext.loginRoute) {
                sessionStorage.removeItem(appContext.tokenStorageKey);
                window.location.href = appContext.loginRoute;
              }
            }
            break;
          case 403:
            errorMessage = 'Acesso negado. Você não tem permissão para acessar este recurso.';
            break;
          case 404:
            errorMessage = 'Recurso não encontrado.';
            break;
          case 500:
            errorMessage = 'Erro interno do servidor. Tente novamente mais tarde.';
            break;
          case 0:
            errorMessage = 'Sem conexão com a internet. Verifique sua rede.';
            break;
          default:
            errorMessage = `Erro inesperado: ${error.message}`;
        }
      }

      return throwError(() => new Error(errorMessage));
    })
  );
};
